const EVENT_MAX_COUNT = 20;
const REQUEST_MAX_SIZE = 1e4;
const EMIT_FREQUENCY = 2e3;
const NOODLE_SPEC_VERSION = "1";

const isBrowser = () => typeof window !== "undefined" && typeof window.document !== "undefined";
const sleep = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  });
};
const getCurrentTimestamp = () => (/* @__PURE__ */ new Date()).getTime();

class Queue {
  constructor() {
    this.elements = [];
  }
  push(element) {
    this.elements.push(element);
  }
  size() {
    return this.elements.length;
  }
  stringifiedLength() {
    return JSON.stringify(this.elements).length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  retrieve(nbElements) {
    if (this.isEmpty()) {
      throw new Error("Queue is empty");
    }
    return this.elements.splice(0, nbElements);
  }
  empty() {
    this.elements = [];
  }
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const awaitingEvents = [];
let queue;
let noodleUrl;
let appInfos;
let context = {};
let appEnv;
let isWaitingForFlush = false;
let hooks = {
  attempt: () => null,
  fail: () => null,
  success: () => null
};
const flush = () => __async(void 0, null, function* () {
  isWaitingForFlush = false;
  if (!queue.isEmpty()) {
    const currentTimestamp = getCurrentTimestamp();
    const events = queue.retrieve(EVENT_MAX_COUNT).map((event) => __spreadProps(__spreadValues({}, event), {
      lifecycle: __spreadProps(__spreadValues({}, event.lifecycle), {
        sent_ts: currentTimestamp
      })
    }));
    hooks.attempt();
    try {
      if (isBrowser()) {
        navigator.sendBeacon(noodleUrl, JSON.stringify(events));
      }
      hooks.success();
    } catch (error) {
      hooks.fail(error);
    }
  }
});
const createEvent = ({ name, version, data }) => {
  const event = {
    data,
    meta: context,
    name,
    version
  };
  if (isBrowser()) {
    event.meta.url = window.location.href;
  }
  return {
    event,
    event_name: name,
    lifecycle: {
      created_ts: getCurrentTimestamp()
    },
    meta: {
      app_info: appInfos,
      env: appEnv
    },
    spec_version: NOODLE_SPEC_VERSION,
    tags: []
  };
};
const push = (event) => __async(void 0, null, function* () {
  if (!queue) {
    awaitingEvents.push(event);
    return false;
  }
  const eventLength = JSON.stringify(event).length;
  if (eventLength >= REQUEST_MAX_SIZE - queue.stringifiedLength()) {
    flush();
  }
  queue.push(createEvent(event));
  if (queue.size() === EVENT_MAX_COUNT) {
    flush();
  }
  if (!isWaitingForFlush && !queue.isEmpty()) {
    isWaitingForFlush = true;
    yield sleep(EMIT_FREQUENCY);
    yield flush();
  }
  return true;
});
const initNoodleClient = ({
  app,
  url,
  env,
  userContext,
  hooks: noodleCustomHooks
}) => {
  noodleUrl = url;
  appInfos = app;
  appEnv = env;
  queue = new Queue();
  if (userContext) {
    context = userContext;
  }
  if (hooks) {
    hooks = __spreadValues(__spreadValues({}, hooks), noodleCustomHooks);
  }
  if (isBrowser()) {
    window.addEventListener("beforeunload", flush);
  }
  if (awaitingEvents.length > 0) {
    awaitingEvents.forEach(push);
    awaitingEvents.length = 0;
  }
};

export { flush, initNoodleClient, push };
